import { Subscription } from 'rxjs';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { AvantoModalControlService } from 'src/app/services/avanto-modalControl.service';
import { AvantoRoutingService, goToThirdPartyDeliveryWebsite } from 'src/app/services/avanto-routing.service';
import { AvantoSessionService } from 'src/app/services/avanto-session.service';
import { AvantoUserAuthService } from 'src/app/services/avanto-user-auth.service';
import { SessionCustomerAddress } from 'src/app/avantoeats-util/models/session/SessionCustomerAddress';
import { SessionObject } from 'src/app/avantoeats-util/models/session/SessionObject';
import { AvantoAlert } from 'src/app/util/Alerts';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  useTransparentBackground: boolean;
  hideChangeLocationAndAddressButton: boolean;
  hideCartButton: boolean;
  hideCustomerPortalButton: boolean;
  hideBottomShadow: boolean;
  headerIsFixedAtTopForMobile:boolean;
  showBigCenterLogo:boolean;

  sessionObserver: Subscription;

  sessionId:string;
  numberOfItemsInsideOfCart: number;
  orderType: string;
  orderDate: string;
  customerAddress: string;
  deliveryPreparationTime: string;
  pickupPreparationTime: string;
  
  authenticationBtnText:string;
  
  selectedRestaurantId:string;
  isOneRestaurantMode:boolean;
  showPickupOnly:boolean
  showOverlay:boolean;

  thirdPartyDeliveryLink:string;

  
  //The following attributes................................
  selectedPageShouldOpenModalIfNoAddressForDelivery:boolean;
  //--- MODAL ATTRIBUTES END ---\\

  constructor(private angularRouter: Router, public auth: AvantoUserAuthService, private avantoSession: AvantoSessionService, 
              private avantoRoute: AvantoRoutingService, private avantoModal: AvantoModalControlService) { }

  ngOnInit() {
    this.isOneRestaurantMode = false;
    this.showPickupOnly = false;

    this.changeNavbarLayout(this.angularRouter.url); 
    //The following code observes which route the user is at and act accordingly
    this.angularRouter.events.subscribe(event => {
      //Override values - depends on the page
      if (event instanceof NavigationStart) {
        this.changeNavbarLayout(event.url)
      }
    })

    this.sessionObserver = this.avantoSession.sessionSubject.subscribe(session => {
      if (session != null) {
        this.numberOfItemsInsideOfCart = session.cart.cartItems.size;
        this.sessionId = session.sessionId;
        this.orderType = session.orderType
        this.orderDate = session.orderDate;

        this.isOneRestaurantMode = session.isOneRestaurantMode;
        if(this.isOneRestaurantMode && session.restaurantInformation!=null){
            this.showPickupOnly = session.restaurantInformation.hasPickup && !session.restaurantInformation.hasDelivery;
            this.selectedRestaurantId = session.restaurantInformation.restaurantId
        }

        if (session.customerAddress != null) {
          this.customerAddress = session.customerAddress.getAddressStr()
        }else{
          this.customerAddress = SessionCustomerAddress.NO_ADDRESS_STR;
        }

        if(session.restaurantInformation!=null){
          if(session.restaurantInformation.minTimeForPickup!=null && session.restaurantInformation.minTimeForPickup>0){
            this.pickupPreparationTime = session.restaurantInformation.minTimeForPickup + " min";
          }else{
            this.pickupPreparationTime = null;
          }

          if(session.restaurantInformation.minTimeForDelivery!=null && session.restaurantInformation.minTimeForDelivery>0){
            this.deliveryPreparationTime = session.restaurantInformation.minTimeForDelivery + " min";
          }else{
            this.deliveryPreparationTime = null;
          }


          this.thirdPartyDeliveryLink = null;
          if(session.restaurantInformation.aboutRestaurant!=null && 
            session.restaurantInformation.aboutRestaurant.additionalContent!=null && 
            session.restaurantInformation.aboutRestaurant.additionalContent.thirdPartyDeliveryWebsite!=null){
            this.thirdPartyDeliveryLink = session.restaurantInformation.aboutRestaurant.additionalContent.thirdPartyDeliveryWebsite;
          } 


        }else{
          this.pickupPreparationTime = null;
          this.deliveryPreparationTime = null;
        }

        //If there is no customer address specified you have DELIVERY selected, but no customer address we will open a popup asking for the delivery address information, if the page you are at
        // wants that behaviour to happen (due to the variable "selectedPageShouldOpenModalIfNoAddressForDelivery" being set to true)
        if(this.customerAddress == SessionCustomerAddress.NO_ADDRESS_STR && this.orderType == SessionObject.ORDER_TYPE_DELIVERY && this.selectedPageShouldOpenModalIfNoAddressForDelivery){
              this.selectedPageShouldOpenModalIfNoAddressForDelivery = false; //We set this flag to false, just so this code isnt called multiple times
              this.changeLocationOrderTypeClicked();//we then open the modal!
            }
        }
    })
  }

  redirectToDeliveryWebsite(){
    goToThirdPartyDeliveryWebsite(this.thirdPartyDeliveryLink);
  }

  /** Called every time the route changes */
  changeNavbarLayout(route) {
    this.useTransparentBackground = false;
    this.hideChangeLocationAndAddressButton = false;
    this.hideCartButton = false;
    this.hideCustomerPortalButton = false;
    this.hideBottomShadow = false;
    this.headerIsFixedAtTopForMobile = true;
    this.selectedPageShouldOpenModalIfNoAddressForDelivery = false;
    this.showBigCenterLogo = false;

    //TODO:
    // this.authenticationBtnText = this.auth.isAuthenticated()?"My Account":"Sign In";
    this.authenticationBtnText = "My Account";

    //event.URL will contain the current route, as defined on the app.module.ts
    if (route == "/") {
      //Initial page, referring to ChooseLocationPage
      this.useTransparentBackground = true;
      this.hideChangeLocationAndAddressButton = true;
      this.hideCartButton = true;
      this.hideBottomShadow = true;
    } else if (route == "/checkout" || route.startsWith("/square/checkout")) {
      this.hideChangeLocationAndAddressButton = true;
      this.showBigCenterLogo = true;
      this.headerIsFixedAtTopForMobile = false;
      this.hideCartButton = true;
    } else if (route == "/checkout/success") {
      this.hideChangeLocationAndAddressButton = true;
      this.hideCustomerPortalButton = true;
      this.hideCartButton = true;
      this.showBigCenterLogo = true;
    }else if (route == "/choose-restaurant") {
      this.hideChangeLocationAndAddressButton = false;
      this.hideBottomShadow = true;
    } else if (route.startsWith("/restaurant") || route.startsWith("/menu")) {
      this.headerIsFixedAtTopForMobile = false;
      this.selectedPageShouldOpenModalIfNoAddressForDelivery = true;
    } else if (route.startsWith("/customer")) {
      this.hideChangeLocationAndAddressButton = true;
      this.hideCustomerPortalButton = true;
      this.showBigCenterLogo = true;
      this.headerIsFixedAtTopForMobile = false;
    }
  }

  ngOnDestroy() {
    this.sessionObserver.unsubscribe();
  }

  openCartModal() {
    this.avantoModal.openCartModal();
  }

  openCustomerPortal() {
    this.avantoRoute.goToCustomerDashboardPage();
    // this.avantoRoute.goToCustomerLoginPage();
  }

  avantoLogoClicked() {
    if(this.isOneRestaurantMode==false){
      this.avantoRoute.goToInitialPage();
    }else{
      const restaurantIdSplit = this.selectedRestaurantId.split(".")
      this.avantoRoute.goToOneRestaurantModeChooseFoodPage(restaurantIdSplit[0],restaurantIdSplit[1])
    }
  }

  chageOrderType(deliveryClicked) {
    if(!this.showPickupOnly){
      this.showOverlay = true;
      const newOrderType = deliveryClicked ? SessionObject.ORDER_TYPE_DELIVERY : SessionObject.ORDER_TYPE_PICKUP;
  
      try {
        this.avantoSession.setOrderType(this.sessionId, newOrderType).then(() => {
          this.showOverlay = false;
          AvantoAlert.toast("success","Order type changed!");
        });
      } catch (ex) {
        this.showOverlay = false;
        AvantoAlert.toast("error","Could not change order type");
      }
    }
  }

  changeLocationOrderTypeClicked() {
    if(this.showPickupOnly){
      this.avantoModal.openOrderDetailsModal(false, true, false);
    }else{
      this.avantoModal.openOrderDetailsModal(true, true, true);
    }
  }
}
